var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CardContent, CardHeader, Chip, Divider, Tooltip, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import { Notification } from '../../../../components/Notification';
import { HandleError } from '../../../utils/HandleError';
import { RequerimentosApi } from '../../../../apis/requerimento-api';
import { FileUtil } from '../../../utils/FileUtil';
import { ShowContent } from '../../../../components/ShowContent';
import { GenericFileUpload } from '../../../../components/Upload/GenericFileUpload';
import DOMPurify from 'dompurify';
import './ChecklistAnexoList.css';
var ChecklistAnexoListProps = /** @class */ (function () {
    function ChecklistAnexoListProps() {
    }
    return ChecklistAnexoListProps;
}());
export { ChecklistAnexoListProps };
export var ChecklistAnexoList = function (_a) {
    var _b, _c, _d;
    var requerimento = _a.requerimento, checklist = _a.checklist, onValidate = _a.onValidate;
    //region Constants
    var _e = useState(undefined), idSelecionado = _e[0], setIdSelecionado = _e[1];
    var _f = useState({
        open: false,
        message: '',
        severity: 'info'
    }), notification = _f[0], setNotification = _f[1];
    var _g = useState(null), checklistMod = _g[0], setChecklistMod = _g[1];
    var _h = useState([]), fileErrors = _h[0], setFileErrors = _h[1];
    var _j = useState(undefined), error = _j[0], setError = _j[1];
    var _k = useState(false), loading = _k[0], setLoading = _k[1];
    var mapIndex = useMemo(function () {
        var _a;
        if (!checklistMod)
            return [];
        var globalIndex = 0;
        return ((_a = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, sessao, indexSessao) {
            var _a;
            var itensIndexados = ((_a = sessao.itens) === null || _a === void 0 ? void 0 : _a.map(function (item, indexItem) { return ({
                indexItem: indexItem,
                indexSessao: indexSessao,
                idItem: item === null || item === void 0 ? void 0 : item.id,
                indexGlobal: ++globalIndex,
            }); })) || [];
            return __spreadArray(__spreadArray([], acc, true), itensIndexados, true);
        }, [])) || [];
    }, [checklistMod]);
    //endregion
    //region Hooks
    useEffect(function () {
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(handleValidate);
    }, [requerimento, checklistMod, fileErrors]);
    useEffect(function () {
    }, []);
    useEffect(function () {
    }, [mapIndex]);
    useEffect(function () {
        var _a, _b;
        if (checklist) {
            var _sessoes = (_b = ((_a = checklist === null || checklist === void 0 ? void 0 : checklist.sessoes) === null || _a === void 0 ? void 0 : _a.map(function (sessao, indexSessao) {
                var _a;
                var _itens = ((_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _a === void 0 ? void 0 : _a.map(function (sessaoItem, indexItem) {
                    var _a, _b;
                    if ((sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.visible) || ((_b = ((_a = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        return sessaoItem;
                    }
                    return undefined;
                }).filter(function (it) { return !!it; })) || [];
                if (_itens.length > 0) {
                    return __assign(__assign({}, sessao), { itens: _itens });
                }
                return undefined;
            }).filter(function (it) { return !!it; }))) !== null && _b !== void 0 ? _b : [];
            setChecklistMod(__assign(__assign({}, checklist), { sessoes: __spreadArray([], _sessoes, true) }));
        }
    }, [checklist]);
    var sessaoVazia = useMemo(function () {
        var _a, _b;
        return ((_b = ((_a = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) === 0;
    }, [(_c = ((_b = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.length, checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes]);
    //endregion
    //region Handles
    var globalIndex = useCallback(function (indexSessao, indexItem) {
        var _a;
        return (_a = mapIndex.find(function (it) { return it.indexSessao === indexSessao && it.indexItem === indexItem; })) === null || _a === void 0 ? void 0 : _a.indexGlobal;
    }, [mapIndex]);
    var item = useCallback(function (idItem) {
        var _a, _b;
        if (!idItem) {
            return undefined;
        }
        var itens = ((_b = (_a = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) === null || _a === void 0 ? void 0 : _a.flatMap(function (it) { var _a; return ((_a = it === null || it === void 0 ? void 0 : it.itens) !== null && _a !== void 0 ? _a : []); })) !== null && _b !== void 0 ? _b : []);
        return itens === null || itens === void 0 ? void 0 : itens.find(function (it) { return (it === null || it === void 0 ? void 0 : it.id) === idItem; });
    }, [checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes]);
    var fileError = useCallback(function (idItem) {
        var _a, _b;
        return (_b = (_a = fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors.find(function (it) { return (it === null || it === void 0 ? void 0 : it.idItem) === idItem; })) === null || _a === void 0 ? void 0 : _a.messageError) !== null && _b !== void 0 ? _b : '';
    }, [fileErrors]);
    var colorChip = useCallback(function (idItem) {
        var _a;
        if (!idItem) {
            return '#ffffff';
        }
        var messageError = fileError(idItem);
        if (messageError) {
            return '#aa2a2a';
        }
        var _item = item(idItem);
        if ((_item === null || _item === void 0 ? void 0 : _item.arquivoBase64) || ((_a = _item === null || _item === void 0 ? void 0 : _item.anexos) === null || _a === void 0 ? void 0 : _a.some(function (anexo) { var _a; return !!(anexo === null || anexo === void 0 ? void 0 : anexo.arquivoBase64) || !!((_a = anexo === null || anexo === void 0 ? void 0 : anexo.anexo) === null || _a === void 0 ? void 0 : _a.hashArquivo); }))) {
            return '#2a960d';
        }
        return '#ffffff';
    }, [item, fileError]);
    //region Arquivos
    var handleValidate = function () {
        var _a;
        var _errors = [];
        (_a = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) === null || _a === void 0 ? void 0 : _a.forEach(function (sessao) {
            var _a;
            (_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if ((item === null || item === void 0 ? void 0 : item.itemObrigatorio) === true && !containsFile(item === null || item === void 0 ? void 0 : item.id)) {
                    _errors.push({ idItem: item === null || item === void 0 ? void 0 : item.id, messageError: 'Arquivo obrigatório.' });
                }
                else {
                    _errors.push({ idItem: item === null || item === void 0 ? void 0 : item.id, messageError: '' });
                }
            });
        });
        setFileErrors(__spreadArray([], _errors, true));
        return _errors.length === 0 || (_errors === null || _errors === void 0 ? void 0 : _errors.every(function (it) { return !(it === null || it === void 0 ? void 0 : it.messageError); }));
    };
    var handleFileChange = function (file, idItem, index) {
        if (file === null && !!idItem) {
            handleDettach(idItem);
            return;
        }
        fileToBase64(file).then(function (base64) {
            if (base64) {
                handleAttach(base64, idItem);
            }
            else {
                handleDettach(idItem, index);
            }
        });
    };
    var handleAttach = function (base64, itemId) {
        var payload = {
            itemId: itemId,
            arquivoBase64: base64
        };
        setIdSelecionado(itemId);
        setLoading(true);
        RequerimentosApi.anexarArquivo(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id, payload)
            .then(function (response) {
            setIdSelecionado(undefined);
            setLoading(false);
            handleChange(itemId, undefined, response);
            setNotification({
                open: true,
                message: 'Arquivo anexado com sucesso.',
                severity: 'success',
                duration: 6000,
                vertical: 'top'
            });
        })
            .catch(function (err) {
            setIdSelecionado(undefined);
            setLoading(false);
            setError(err);
        });
    };
    var handleDettach = function (itemId, index) {
        var reqAnexo = requerimentoAnexo(itemId, index);
        if ((reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64) || (reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.anexo)) {
            var payload = { itemId: itemId, anexoId: reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.anexoId };
            setIdSelecionado(itemId);
            setLoading(true);
            RequerimentosApi.desanexarArquivo(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id, payload)
                .then(function () {
                setIdSelecionado(undefined);
                setLoading(false);
                setNotification({
                    open: true,
                    message: 'Arquivo excluído com sucesso.',
                    severity: 'success',
                    duration: 6000,
                    vertical: 'top'
                });
                handleChange(itemId, index);
            })
                .catch(function (err) {
                setIdSelecionado(undefined);
                setLoading(false);
                setError(err);
            });
        }
    };
    var handleChange = function (idItem, indexAnexo, reqAnexo) {
        var _a;
        var _sessoes = ((_a = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) === null || _a === void 0 ? void 0 : _a.map(function (sessao) {
            var _itens = refactorItens(sessao, idItem, indexAnexo, reqAnexo);
            return __assign(__assign({}, sessao), { itens: __spreadArray([], _itens, true) });
        })) || [];
        setChecklistMod(__assign(__assign({}, checklistMod), { sessoes: __spreadArray([], _sessoes, true) }));
        handleFileErrorChange('', idItem);
    };
    var refactorItens = function (sessao, idItem, indexAnexo, reqAnexo) {
        var _a;
        return ((_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            var _a, _b, _c;
            if ((item === null || item === void 0 ? void 0 : item.id) === idItem) {
                if (!reqAnexo) {
                    var newAnexos = (_b = (_a = item === null || item === void 0 ? void 0 : item.anexos) === null || _a === void 0 ? void 0 : _a.filter(function (ra, index) { return index !== indexAnexo; })) !== null && _b !== void 0 ? _b : [];
                    return __assign(__assign({}, item), { anexos: __spreadArray([], newAnexos, true) });
                }
                else {
                    var newAnexos = __spreadArray(__spreadArray([], ((_c = item === null || item === void 0 ? void 0 : item.anexos) !== null && _c !== void 0 ? _c : []), true), [reqAnexo], false);
                    return __assign(__assign({}, item), { anexos: __spreadArray([], newAnexos, true) });
                }
            }
            return item;
        })) || [];
    };
    var handleFileErrorChange = function (messageError, idItem) {
        var _error = fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors.some(function (it) { return (it === null || it === void 0 ? void 0 : it.idItem) === idItem; });
        if (_error) {
            var _errors = fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors.map(function (it, index) {
                if ((it === null || it === void 0 ? void 0 : it.idItem) === idItem) {
                    return { idItem: idItem, messageError: messageError };
                }
                return it;
            });
            setFileErrors(__spreadArray([], _errors, true));
        }
        else {
            setFileErrors(__spreadArray(__spreadArray([], fileErrors, true), [{ idItem: idItem, messageError: messageError }], false));
        }
    };
    var fileToBase64 = useCallback(function (file) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, FileUtil.fileToBase64(file)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, []);
    var base64ToFile = useCallback(function (base64) {
        return FileUtil.base64ToFile(base64);
    }, []);
    //region @Callbacks
    var containsFile = useCallback(function (idItem) {
        var _a;
        if (!idItem) {
            return false;
        }
        var _item = item(idItem);
        return !!(_item === null || _item === void 0 ? void 0 : _item.anexos) && ((_a = _item === null || _item === void 0 ? void 0 : _item.anexos) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }, [item]);
    var requerimentoAnexo = useCallback(function (idItem, index) {
        if (idItem === undefined || index === undefined) {
            return undefined;
        }
        var _item = item(idItem);
        if (!(_item === null || _item === void 0 ? void 0 : _item.anexos)) {
            return undefined;
        }
        return _item === null || _item === void 0 ? void 0 : _item.anexos[index];
    }, [item]);
    var files = useCallback(function (idItem) {
        var _a, _b;
        if (!idItem) {
            return [];
        }
        var _item = item(idItem);
        return (_b = (_a = _item === null || _item === void 0 ? void 0 : _item.anexos) === null || _a === void 0 ? void 0 : _a.map(function (reqAnexo) {
            var _a;
            if (reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64)
                return base64ToFile(reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64);
            if ((_a = reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.anexo) === null || _a === void 0 ? void 0 : _a.nomeArquivo)
                return new File([new Blob()], reqAnexo.anexo.nomeArquivo, { type: reqAnexo.anexo.extensao || '' });
            return null;
        }).filter(function (it) { return !!it; })) !== null && _b !== void 0 ? _b : [];
    }, [base64ToFile, item]);
    //endregion
    //endregion
    var renderize = useCallback(function (textHtml) {
        return DOMPurify.sanitize(textHtml || '');
    }, []);
    return (_jsxs("div", __assign({ style: { width: '100%' } }, { children: [_jsx(ShowContent, __assign({ show: !sessaoVazia }, { children: _jsx(_Fragment, { children: (_d = checklistMod === null || checklistMod === void 0 ? void 0 : checklistMod.sessoes) === null || _d === void 0 ? void 0 : _d.map(function (sessao, indexSessao) {
                        var _a, _b;
                        return (_jsxs(Card, __assign({ style: { marginBottom: '20px', marginLeft: '4px', padding: '10px' } }, { children: [_jsx(CardHeader, { sx: { padding: '5px 15px 15px 15px' }, title: _jsx(Typography, __assign({ className: 'card-header-title' }, { children: sessao === null || sessao === void 0 ? void 0 : sessao.nome })), subheader: _jsxs(_Fragment, { children: [_jsx(Typography, { className: "card-header-sub-title", dangerouslySetInnerHTML: { __html: renderize((_a = sessao === null || sessao === void 0 ? void 0 : sessao.descricao) !== null && _a !== void 0 ? _a : '') } }), _jsx(Typography, __assign({ className: 'card-header-sub-title' }, { children: "o arquivo deve ser no formato PDF, JPG, PNG, GIF, BMP e JPEG. O tamanho m\u00E1ximo n\u00E3o pode ultrapassar 25mb." }))] }) }), _jsx(CardContent, { children: _jsxs("div", __assign({ style: { display: 'inline-flex', width: '100%' } }, { children: [_jsx("div", { style: { background: '#c5c5c5', height: 'auto', width: '50px' } }), _jsx("div", __assign({ style: { display: 'grid', width: '95%' } }, { children: (_b = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _b === void 0 ? void 0 : _b.map(function (item, indexItem) {
                                                    var _a, _b, _c;
                                                    return (_jsxs(React.Fragment, { children: [_jsx(Divider, {}), _jsx("div", __assign({ style: { textAlign: 'left', margin: '10px 0 0 -37px' } }, { children: _jsx(Tooltip, __assign({ componentsProps: {
                                                                        tooltip: {
                                                                            sx: {
                                                                                fontSize: '1rem',
                                                                                maxWidth: 1000,
                                                                                padding: '12px 16px',
                                                                            },
                                                                        },
                                                                    }, title: _jsx(Typography, __assign({ color: "inherit", fontSize: 12 }, { children: (_a = item === null || item === void 0 ? void 0 : item.expressao) !== null && _a !== void 0 ? _a : '' })) }, { children: _jsx(Chip, { sx: {
                                                                            color: (colorChip(item === null || item === void 0 ? void 0 : item.id) !== '#ffffff' ? '#ffffff' : '#000000'),
                                                                            background: "".concat(colorChip(item === null || item === void 0 ? void 0 : item.id)),
                                                                            position: 'absolute',
                                                                            letterSpacing: '0.16px',
                                                                            cursor: 'pointer',
                                                                            lineHeight: '14px',
                                                                            overflow: 'auto',
                                                                            fontSize: '14px',
                                                                            fontWeight: 400
                                                                        }, label: "".concat(globalIndex(indexSessao, indexItem)), size: "small" }, "chip-".concat(indexItem.toString(), "_").concat(indexSessao === null || indexSessao === void 0 ? void 0 : indexSessao.toString())) })) })), _jsx(Card, __assign({ style: { marginTop: '0', marginBottom: '0' } }, { children: _jsx(CardHeader, { sx: {
                                                                        padding: '5px 15px 15px 15px',
                                                                        display: 'flex',
                                                                        flexDirection: { xs: 'column', md: 'row' },
                                                                        alignItems: { xs: 'flex-start', md: 'center' },
                                                                        '& .MuiCardHeader-content': {
                                                                            flex: 1,
                                                                            minWidth: 0
                                                                        },
                                                                        '& .MuiCardHeader-action': {
                                                                            margin: { xs: '16px 0 0 0', md: '0' },
                                                                            alignSelf: { xs: 'stretch', md: 'auto' }
                                                                        }
                                                                    }, action: _jsx(GenericFileUpload, { onChange: function (value, index) { return handleFileChange(value, item === null || item === void 0 ? void 0 : item.id, index); }, onError: function (error) { return handleFileErrorChange(error, item === null || item === void 0 ? void 0 : item.id); }, id: "anexo-sesssao_".concat(indexSessao, "_item_").concat(indexItem), loading: loading && idSelecionado === (item === null || item === void 0 ? void 0 : item.id), multiple: (_b = item === null || item === void 0 ? void 0 : item.multiplosArquivos) !== null && _b !== void 0 ? _b : false, disabled: !(item === null || item === void 0 ? void 0 : item.visible) || loading, typeDocument: item === null || item === void 0 ? void 0 : item.tipoDocumento, files: files(item === null || item === void 0 ? void 0 : item.id), extensionsAccept: [] }), style: { textAlign: 'left' }, title: _jsx(Typography, __assign({ className: 'card-header-title' }, { children: item === null || item === void 0 ? void 0 : item.nomeDocumento })), subheader: _jsxs(_Fragment, { children: [_jsx(Typography, { className: "card-header-sub-title", dangerouslySetInnerHTML: { __html: renderize((_c = item === null || item === void 0 ? void 0 : item.descricao) !== null && _c !== void 0 ? _c : '') } }), _jsx(ShowContent, __assign({ show: !!fileError(item === null || item === void 0 ? void 0 : item.id) }, { children: _jsx(Typography, __assign({ className: 'card-header-sub-title', fontWeight: 'bold', style: { color: '#aa2a2a' } }, { children: fileError(item === null || item === void 0 ? void 0 : item.id) })) }))] }) }) })), _jsx(Divider, {})] }, "sessao_".concat(indexSessao === null || indexSessao === void 0 ? void 0 : indexSessao.toString(), "_item_").concat(indexItem === null || indexItem === void 0 ? void 0 : indexItem.toString())));
                                                }) })), _jsx("div", { style: { background: '#c5c5c5', height: 'auto', width: '1px' } })] })) })] }), "sessao_".concat(indexSessao === null || indexSessao === void 0 ? void 0 : indexSessao.toString())));
                    }) }) })), _jsx(ShowContent, __assign({ show: sessaoVazia }, { children: _jsx(Card, __assign({ style: { marginBottom: '20px', padding: '10px' } }, { children: _jsx(CardHeader, { sx: { padding: '5px 15px 15px 15px' }, title: _jsx(Typography, __assign({ className: 'card-header-title', textAlign: 'center' }, { children: "N\u00E3o existe nenhuma op\u00E7\u00E3o de envio de documentos para esse requerimento." })) }) }), "no_sessao") })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } }), _jsx(Notification, { handleFormChange: setNotification, props: notification })] })));
};
